<template>
  <div class="app-container">
    <el-calendar v-model="value">
      <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
      <template slot="dateCell" slot-scope="{ data }">
        <div
          :class="activeDay.includes(data.day) ? 'is-holiday' : ''"
          class="el-calendar"
          @click="
            roles.includes('/conf/set_national_holiday')
              ? calendarOnClick(data)
              : ''
          "
        >
          {{ data.day.split("-").slice(2).join("-") }}
          <!-- <div v-for="item in activeday">
            <el-badge  v-if="data.day == item.dat" :value="item.coun"></el-badge>
          </div> -->
          <!-- {{ activeDay.includes(data.day)  ? "假" : "" }} -->
          <el-tag type="danger" v-if="activeDay.includes(data.day)"
            >节假日</el-tag
          >
        </div>
      </template>
    </el-calendar>
    <div class="tips"><span>*</span> 点击设置节假日，再次点击可取消</div>
  </div>
</template>

<script>
import { setHoliday, getHoliday } from "@/api/conf";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  watch: {
    // value: {
    //   //监听月份变化
    //   handler(newValue, oldValue) {
    //     this.initData();
    //   },
    // },
  },
  data() {
    return {
      value: new Date(),
      activeDay: [],
    };
  },
  created() {
    this.getActivityCalendar();
  },
  mounted() {
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", () => {
        this.getActivityCalendar();
      });
      let dayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      dayBtn.addEventListener("click", () => {
        this.getActivityCalendar();
      });
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        this.getActivityCalendar();
      });
    });
  },
  methods: {
    set(time) {
      var that = this;
      setHoliday({ date: time }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          that.getActivityCalendar();
        }
      });
    },
    //点击日期块
    calendarOnClick(e) {
      var that = this;
      // this.isArrange.push("2020-06-19");
      if (!this.activeDay.includes(e.day)) {
        this.$confirm("是否将" + e.day + "设为节假日?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            that.set(e.day);
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
          })
          .catch(() => {});
      } else {
        this.$confirm("是否取消" + e.day + "为节假日?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            that.set(e.day);
            // this.$message({
            //   type: "success",
            //   message: "删除成功!",
            // });
          })
          .catch(() => {});
      }
    },
    getActivityCalendar() {
      var that = this;
      let year = this.value.getFullYear(); //获取完整的年份(4位)
      let month = this.value.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      getHoliday({ year: year, month: month }).then((response) => {
        that.activeDay = [];
        // that.activeDay = response.data.lists
        if (response.data.lists.length > 0) {
          response.data.lists.forEach((item, index) => {
            that.activeDay.push(item.date);
          });
        }
        //返回数据为日期以及该日期对应的事件个数，用标记显示
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 60px;
}
.is-selected {
  color: #1989fa;
}
.is-holiday {
  color: red;
}
.el-calendar {
  height: 100%;
  background: transparent;
}
::v-deep .el-calendar-table__row td.prev {
  pointer-events: none;
  .el-calendar-day {
    display: none;
  }
}

::v-deep .el-calendar-table__row td.next {
  pointer-events: none;
  .el-calendar-day {
    display: none;
  }
}
.tips {
  color: #f56c6c;
  font-size: 14px;
  padding: 0 20px;
  span {
    font-size: 16px;
  }
}
</style>
